function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", {
  id: "defs4489"
});

var SvgDdtLogo = function SvgDdtLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "svg4485",
    width: 1174.72,
    height: 563.52002,
    viewBox: "0 0 1174.72 563.52002",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    }
  }), React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    }
  }), React.createElement("g", {
    id: "layer4",
    style: {
      display: "inline"
    }
  }), React.createElement("g", {
    id: "layer5",
    style: {
      display: "inline"
    }
  }), React.createElement("g", {
    id: "layer3"
  }, React.createElement("g", {
    id: "g4953",
    transform: "matrix(0.99419393,0,0,0.98664808,2140.0539,1378.0529)"
  }, React.createElement("path", {
    id: "path4496",
    d: "m -2148.27,-1137.3768 89.9394,100.5355 3.1665,206.5858 110.3087,-255.9727 c 51.225,-48.8758 110.1132,-81.4673 176.4231,-98.2878 124.8778,-28.9088 184.7966,-18.2578 249.9623,-12.3744 76.2067,12.6278 153.9826,31.7932 235.8201,67.8823 m 0,0 -54.1041,121.2688 359.22066,-51.9723 -213.89976,-255.9727 -83.7922,161.9274 c -64.6978,-28.3684 -128.5639,-45.0905 -192.3331,-60.4576 -110.1196,-21.8409 -221.7627,-24.1817 -336.5828,14.1422 -40.1539,15.9247 -75.0362,24.0219 -144.9569,84.1457 v 0 l -199.1719,-21.4502",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#f79312",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("g", {
    id: "g4579"
  }, React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -1924.7029,-1092.0618 -1.4142,-3.8891 c 6.4625,-2.7583 10.4658,-5.1653 14.6725,-7.6014 9.3858,-2.9466 18.285,-6.7448 26.3397,-12.0208 23.6249,-9.9138 47.3393,-19.5291 71.9481,-26.1629 l 6.8943,-0.1768 -0.8839,7.2478 -49.3207,15.026 -4.4194,5.1266 c 4.3502,23.4455 9.1208,47.1713 12.5511,70.0035 l -5.8336,6.0105 c -4.7919,-0.5988 -9.4792,-1.1452 -13.6118,-1.4143 -2.4175,-1.7118 -4.8566,-3.4671 -7.6014,-5.8336 l 4.2426,-8.1317 -5.6568,-15.026 -0.5303,-27.9308 -8.6621,-9.8995 c -11.3024,5.0113 -22.3416,8.706 -33.9411,15.2028 z",
    id: "path4740"
  }), React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -1793.181,-1148.1 c -0.015,2.2213 -2.2262,6.089 -6.0104,11.1369 1.7027,26.6262 3.2282,53.0161 3.5355,77.7818 l 3.7123,5.4801 -1.9445,12.5511 18.7383,18.208 c 5.6545,4.8648 13.6056,6.2848 21.0364,8.4853 l 29.1682,-12.5512 c 7.8376,-11.3293 13.3852,-18.6511 19.4454,-26.87 l 24.9255,-111.5461 7.6014,-9.1924 c 0.072,-3.1482 -0.3186,-5.3731 -0.7071,-7.6014 -3.1985,-0.848 -4.6791,-1.8188 -7.071,-2.6516 l -15.91,2.8284 -4.7729,6.5407 -5.3033,42.2496 -17.6777,67.5287 -26.8701,28.6379 -11.1369,2.2981 c -4.7239,-4.4514 -9.23,-8.8483 -10.253,-12.3744 l 0.7071,-105.5357 c -3.0052,0.7458 -6.0104,0.099 -9.0156,0 -3.2822,2.7076 -8.0798,3.1421 -12.1976,4.5962 z",
    id: "path4742"
  }), React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -1696.1382,-986.46623 6.3125,3.4375 11.5625,-3.875 36.7566,-111.87557 6.1872,-9.5459 c 7.2215,21.4752 16.7747,51.1474 19.2686,83.2618 -2.3707,24.1256 -2.4537,46.5353 -7.2478,72.47843 l 1.4142,7.24784 10.0763,5.83363 c 5.8888,-6.04724 13.6681,-13.35474 15.9099,-16.97056 26.9879,-63.16824 53.9758,-128.47784 80.9637,-189.50464 6.6929,-8.9444 12.6715,-17.5316 18.0312,-25.8094 -0.1178,-2.4748 -0.2357,-4.9497 -0.3535,-7.4246 l -7.7782,-7.0711 -12.7279,-1.4142 -15.5564,12.3744 -53.7401,156.9777 -7.7782,7.0711 c -1.2063,-45.786 -11.2357,-87.4997 -20.8596,-129.4006 l 6.3639,-19.799 -6.7175,-12.3743 c -3.711,2.9512 -8.7196,0.7126 -13.0815,1.0606 l -6.7175,6.0104 -11.6672,15.5564 -40.3051,137.8858 c -1.7035,4.4212 -2.3063,9.2093 -7.7782,12.37437 z",
    id: "path4744"
  }), React.createElement("path", {
    id: "path4746",
    transform: "matrix(1.00584,0,0,1.0135326,-2152.5518,-1396.7015)",
    d: "M 765.19531 229.68945 C 756.82271 230.61335 750.51461 234.95242 744.06836 239.0625 C 717.26887 269.39946 705.49632 294.11875 669.65234 338.80078 C 664.06 345.77204 655.74064 351.87214 648.625 359.67969 L 643.1582 360.66797 L 593.44727 428.5 L 583.50586 433.92578 L 579.77734 453.6582 L 606.86914 448.23242 L 698.58398 338.71484 L 722.44531 337.23438 L 749.03906 332.54688 L 752.51953 341.42773 C 753.35525 364.80291 747.23613 387.19203 738.84961 409.25977 C 742.66871 413.46855 746.52041 412.78326 752.26953 422.82617 L 766.18945 407.5332 C 773.60326 384.47803 774.70669 358.91687 775.63477 333.28711 C 777.49381 302.14771 777.8825 267.26099 784.08398 247.20312 C 781.19804 239.24995 778.42127 231.22902 765.19531 229.68945 z M 747.29883 280.50195 C 749.85411 283.09615 751.81999 285.88524 752.39453 289.13477 C 751.61995 297.87331 749.52057 305.79034 751.15234 316.02148 L 748.29297 318.98047 C 735.98167 317.00964 726.16703 320.61009 715.11328 321.44727 C 723.47992 311.90006 732.34454 301.32653 738.59961 293.94531 C 741.48088 289.05154 745.1296 285.10042 747.29883 280.50195 z ",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99041384px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), React.createElement("g", {
    id: "g4628"
  }, React.createElement("path", {
    id: "path4601",
    transform: "matrix(1.00584,0,0,1.0135326,-2152.5518,-1396.7015)",
    d: "M 348.63477 52.882812 L 327.54492 59.685547 C 323.20845 68.756789 319.34899 77.259897 312.78125 88.988281 C 313.19135 94.946057 313.60161 99.04082 314.01172 107.47656 C 319.60187 124.23399 323.15352 141.7995 330.88477 157.70703 C 339.18529 163.67527 345.89228 170.43344 356.71875 175.14844 L 370.95508 175.14844 L 380.44531 170.26562 L 383.78516 163.11523 C 385.35817 154.6642 387.67454 146.33586 392.04492 138.34766 C 393.84471 125.3613 394.75254 111.84434 398.72266 100.15039 L 389.4082 72.941406 L 376.05078 56.894531 L 348.63477 52.882812 z M 355.49414 70.341797 C 358.67699 70.283091 362.03345 70.741515 365.68164 72.068359 L 366.56055 74.859375 L 370.7793 74.685547 C 373.69646 82.650559 378.73441 90.615066 382.90625 98.580078 C 380.59216 106.72358 378.97686 115.75955 379.91797 128.05664 L 377.28125 137.47461 C 372.47512 144.49639 370.15838 153.00185 367.61523 161.37109 L 362.34375 163.63867 L 352.32617 158.92773 L 340.375 148.8125 L 334.04688 134.33594 C 333.4611 122.59196 332.87484 110.84759 332.28906 99.103516 L 335.80469 86.197266 L 346.34961 71.720703 C 349.30251 70.977461 352.31129 70.400502 355.49414 70.341797 z ",
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99041384px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4609",
    d: "m -1746.6789,-1362.7806 c 7.6849,38.4166 13.5997,76.8333 20.375,115.25 1.8947,3.4979 3.3964,6.2094 4.625,8.375 4.1797,-1.2893 8.1531,-1.9594 12,-2.25 -5.036,-25.8818 -8.1477,-52.0385 -10.875,-78.25 -0.2211,-4.1427 0.016,-8.3998 1.125,-12.875 10.9701,11.1645 21.9419,22.3099 32.75,35.25 4.133,-0.6411 8.0751,-0.9003 11.875,-0.875 l 11.125,-41.375 1.875,-1.75 9,45.75 5.625,53.625 c 1.9599,1.0331 4.1977,2.1572 6.5,4.5 l 6.125,-0.5 2.25,-8.375 c -5.5834,-41.0493 -11.1667,-81.8933 -16.75,-123.375 -2.1714,-4.287 -3.6234,-9.2934 -5.375,-14 l -4.25,-4.375 c -3.8753,0.4166 -7.3395,0.8333 -10.75,1.25 -5.4269,19.4679 -11.37,41.5163 -17.25,63.25 l -3.75,-1.125 c -7.5219,-8.4827 -10.6959,-13.161 -14.625,-18.5 l -3.875,-7.375 -20.875,-20.25 -14.75,4.25 z",
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4611",
    d: "m -1625.464,-1265.3458 c 0.9428,3.6828 1.8857,7.3657 2.8285,11.0485 7.8672,2.505 14.8436,4.1192 22.097,6.0104 l 12.9931,1.6794 c 6.2253,-5.4025 9.5915,-7.9459 13.2451,-10.7767 3.5059,-5.1369 6.6953,-9.6406 9.875,-14.125 l 5.625,-15.75 2.625,-17.75 c -1.979,-9.5571 -3.8968,-19.1672 -10.75,-24.5 l -22.75,-7 -13.625,-0.375 -4.25,-2.5 -4.25,-9.5 6.75,-16.125 c 4.4946,-5.8306 9.1721,-8.9183 14,-9.75 l 12.75,20.625 10.875,-0.125 4.125,-4.5 -3.125,-14.625 -8.875,-19.25 -24,0.375 -2.625,2.75 -13.5,9.375 -13.375,30.25 5,16 c 7.5776,6.8821 19.8797,7.8587 31.25,10 l 13.875,6.25 6.875,11.875 -0.875,14.5 c -1.5933,4.204 -2.5532,8.6893 -7,11.625 -2.3702,5.6076 -1.7984,11.3283 -12.25,16.625 l -16.25,-2.125 -12.25,-4.875 -3.125,0.25 z",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4613",
    transform: "matrix(1.00584,0,0,1.0135326,-2152.5518,-1396.7015)",
    d: "M 628.5332 4.8222656 C 624.58248 8.127438 620.38193 11.234296 618.69141 16.333984 C 616.88237 28.942656 615.70762 41.928501 616.23047 55.925781 C 609.09444 76.789738 604.60768 99.735727 599.70898 122.37891 L 601.4668 135.11133 L 599.35742 146.09961 L 600.06055 151.1582 L 603.22461 154.82031 C 620.3322 146.99975 634.47553 141.38545 647.86523 136.33203 C 655.04282 131.90238 661.05577 127.01077 670.36133 123.42578 C 676.33842 116.97537 682.72722 111.34251 689.16602 105.80859 L 695.14258 95.169922 C 697.74359 81.18162 699.22771 66.085682 700.94141 51.216797 C 696.84473 41.391361 693.35508 31.565671 689.69336 21.740234 C 677.24128 14.392962 663.8282 9.2719113 649.97461 5.1699219 L 628.5332 4.8222656 z M 640.73047 24.537109 C 647.30259 25.983634 653.38549 26.30054 660.86133 29.839844 C 666.62179 33.005307 671.49399 36.170474 674.2832 39.335938 C 678.6507 48.057216 682.07437 56.467754 685.46875 64.867188 C 684.83724 73.665326 684.3234 82.774834 682.73438 89.039062 C 678.30783 94.870942 674.10879 100.47699 669.06445 106.92188 C 663.6793 109.82972 658.29345 112.85854 652.9082 116.41797 C 641.30914 120.83855 629.84043 125.17335 617.28516 130.22656 C 616.82256 125.75626 617.21113 122.55856 617.36523 119.00781 C 623.61871 85.994469 632.67233 55.759391 640.73047 24.537109 z ",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99041384px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4621",
    d: "m -1381.1146,-1216.6894 c 1.3717,-3.2573 2.9303,-6.7015 4.773,-10.4298 39.4613,-41.6214 52.9952,-48.8607 71.9481,-63.286 l -3.0052,-2.6517 -1.7678,-9.1924 2.8285,-13.435 c -2.0205,-11.2044 -0.6261,-20.7013 1.0607,-30.052 l 7.7781,-12.5512 7.9549,-1.591 c 3.3601,1.5303 6.4575,3.4543 7.9551,7.7782 -2.3706,16.6924 -5.1547,33.4364 -3.8891,49.6742 l 3.0052,3.7124 56.9221,-36.5928 12.5511,-2.6517 11.6673,2.4749 -8.4853,13.6118 c -20.6522,12.5918 -45.779,24.6243 -70.0036,36.7696 l -3.3587,9.0156 -16.0868,1.591 -25.6326,14.6724 c -8.3296,8.6999 -17.1984,16.8606 -24.2184,26.8701 l -22.2739,18.5615 z",
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4623",
    transform: "matrix(1.00584,0,0,1.0135326,-2152.5518,-1396.7015)",
    d: "M 802.28516 15.976562 C 796.30906 18.309393 791.27913 21.044592 787.62109 24.363281 C 765.53736 49.345901 746.0831 76.356672 721.25977 99.224609 L 718.27734 99.470703 L 688.57422 139.80078 L 684.59766 141.89648 L 678.38477 159.65625 L 688.94727 160.76758 C 707.08663 138.11118 724.87947 115.11009 745.24414 94.662109 C 752.90271 96.888283 761.75874 97.628927 770.7207 98.238281 L 770.96875 103.54102 C 764.02421 122.44805 755.99837 141.20121 746.73438 159.7793 L 754.8125 166.19336 L 766.74414 153.49023 C 776.7167 133.26375 783.06989 111.44141 790.23047 89.974609 C 796.65545 70.047377 803.13724 50.134192 810.86133 30.529297 C 811.46401 20.311471 806.85378 18.175406 802.28516 15.976562 z M 780.41406 58.03125 C 781.13386 60.341388 782.7766 61.902708 781.84375 65.554688 C 779.89334 71.903669 777.43043 78.6341 774.82227 85.472656 L 773.26758 86.458984 C 767.02503 86.449118 760.95624 86.235369 755.37305 85.412109 C 761.28114 79.186163 767.10811 72.600198 773.33008 67.775391 C 775.38269 63.813209 777.87151 60.859082 780.41406 58.03125 z ",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99041384px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4593",
    transform: "matrix(1.00584,0,0,1.0135326,-2152.5518,-1396.7015)",
    d: "M 256.43164 100.46484 C 254.29585 100.46846 252.15063 100.48493 250.00586 100.50195 L 235.58984 108.64258 C 236.31759 117.64633 234.97642 126.19454 232.73242 134.54297 C 234.66653 139.76401 236.92621 144.98403 236.95703 150.20508 C 242.38404 163.37397 247.78965 176.55038 252.24414 190.04102 C 261.63957 194.96005 270.76468 198.00896 279.83203 200.64844 L 294.74414 198.55078 C 297.8326 196.2143 300.52094 194.47582 302.94727 193.125 L 304.6875 186.58789 C 304.40286 178.77532 304.74739 171.31006 307.42188 165.12891 C 304.04172 153.25558 305.44158 143.53726 305.43164 133.18555 C 301.37762 126.54906 297.33296 119.91614 292.63281 112.95898 C 286.69032 108.85196 280.73015 104.71075 275.10938 101.24219 C 269.15935 100.57213 262.83902 100.454 256.43164 100.46484 z M 266.35547 113.85547 C 267.81264 113.88007 269.38798 114.0893 271.13281 114.5625 L 272.625 116.53516 L 276.10352 117.0293 C 282.50264 122.44915 287.22699 128.05413 290.64453 133.80273 C 291.65384 141.35 292.40655 146.75475 293.75 158.22266 L 293.62695 166.48438 C 292.20098 169.38621 289.27851 177.58378 289.15234 186.95703 L 283.93359 190.16406 C 280.16321 189.30607 276.195 188.45125 273.61914 187.57422 C 267.88612 184.88797 264.55076 182.54129 261.06641 180.17383 C 257.03734 176.67942 256.56807 173.18582 254.97656 169.69141 C 253.85819 159.86587 252.80707 149.908 251.37305 140.70898 L 251.24805 128.86914 C 253.02666 123.53128 253.93587 120.3521 255.10156 116.53516 C 258.6817 115.37478 261.98397 113.78167 266.35547 113.85547 z ",
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99041384px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path4693",
    transform: "matrix(1.00584,0,0,1.0135326,-2152.5518,-1396.7015)",
    d: "M 221.42383 169.7168 L 191.36914 169.97852 L 148.57422 189.33789 L 129.94531 202.07031 C 129.91946 204.47616 130.30779 206.9335 132.14258 209.57031 C 141.84482 212.63968 152.63321 213.76785 161.22852 218.81445 L 167.81836 231.28516 C 172.38121 235.63716 177.73676 238.68038 183.28516 241.40234 L 195.67578 242.27344 L 205.60547 244.89062 L 217.64453 244.10547 C 224.24648 235.38646 231.07951 225.51847 237.06445 219.86133 L 243.56641 206.16992 C 243.66384 201.43737 243.46726 196.52985 245.14844 192.74023 L 242.95312 186.37305 L 221.42383 169.7168 z M 200.73242 181.42578 C 206.84993 181.35243 212.79204 181.49835 218.30273 182.17773 C 222.23805 186.20474 226.1721 188.7481 230.10742 191.42773 C 229.495 194.9554 229.20075 198.69132 229.98438 203.14258 C 228.03745 206.45407 226.08951 209.88938 224.14258 214.11914 C 217.30233 218.60957 211.70339 225.76799 206.24805 233.23633 L 194.81445 230.64648 C 182.76572 219.86972 170.97149 208.84058 159.14844 197.83984 C 165.02512 194.44548 170.84062 191.0204 177.16797 187.84961 L 194.56641 181.56055 C 196.63527 181.49925 198.69325 181.45023 200.73242 181.42578 z ",
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.99041384px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), React.createElement("g", {
    transform: "translate(-530,-592)",
    id: "g4802"
  }, React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#241f1c",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -670.00062,-571.23142 26.5,-25.25 -11,-28 20.5,19.25 21.75002,-10 -15.50002,16.5 9.25002,28.5 -19.25002,-20 z",
    id: "path4499"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -652.66465,-584.21809 12.8125,-11.875 -6.9375,-16.0625 12.25,10.625 18.31252,-10.0625 -14.56252,13.75 6.3125,17.9375 -12.0625,-13.75 z",
    id: "path4502"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDdtLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ddt-logo.33463208.svg";
export { ForwardRef as ReactComponent };